function resetHiddenInputValue(input: HTMLInputElement | null | undefined) {
  if (!input) {
    return;
  }

  input.value = "";
}

export { resetHiddenInputValue };
